/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Tab_AgbwInputs */

const en_project_tab_agbw = /** @type {(inputs: Project_Tab_AgbwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGBW`)
};

const nl_project_tab_agbw = /** @type {(inputs: Project_Tab_AgbwInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AGBW`)
};

/**
* | output |
* | --- |
* | "AGBW" |
*
* @param {Project_Tab_AgbwInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const project_tab_agbw = /** @type {((inputs?: Project_Tab_AgbwInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Tab_AgbwInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_project_tab_agbw(inputs)
	return en_project_tab_agbw(inputs)
});